import { GENRES } from "@/lib/genres";
import { CheckCircle } from "@phosphor-icons/react";

/**
 * Vertical text list of genres with a "Seleccionar" button per row.
 * No images here (kept only on Landing hero, per product decision).
 */
export const GenrePicker = ({ genre, onSelect }) => {
  return (
    <div className="space-y-2" data-testid="genre-picker">
      {GENRES.map(g => {
        const on = genre === g.key;
        return (
          <div
            key={g.key}
            className={`flex items-center justify-between gap-3 px-4 py-3 rounded-xl border transition-all ${
              on
                ? "bg-[#FFB800]/10 border-[#FFB800]"
                : "bg-[#121212] border-white/10 hover:border-white/25"
            }`}
          >
            <div className="flex-1 min-w-0">
              <p className="font-display font-bold text-base leading-tight">{g.name}</p>
              <p className="text-xs text-white/50 mt-0.5 line-clamp-1">{g.tagline}</p>
            </div>
            <button
              type="button"
              onClick={() => onSelect(g.key)}
              data-testid={`pick-genre-${g.key}`}
              className={`px-4 py-2 rounded-full text-[11px] font-bold uppercase tracking-wider transition-all active:scale-95 shrink-0 inline-flex items-center gap-1.5 ${
                on
                  ? "bg-[#FFB800] text-black"
                  : "bg-white/5 border border-white/20 text-white hover:bg-white/10"
              }`}
            >
              {on ? (<><CheckCircle weight="fill" size={13} /> Seleccionado</>) : "Seleccionar"}
            </button>
          </div>
        );
      })}
    </div>
  );
};
